export var VelavuRole;
(function (VelavuRole) {
    VelavuRole["Viewer"] = "VIEWER";
    VelavuRole["Operator"] = "OPERATOR";
    VelavuRole["SiteManager"] = "SITE_MANAGER";
    VelavuRole["Admin"] = "ADMIN";
})(VelavuRole || (VelavuRole = {}));
//# sourceMappingURL=role.js.map